import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "tw-mb-1 tw-flex tw-items-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioBadge = _resolveComponent("StudioBadge")!
  const _component_StudioToggle = _resolveComponent("StudioToggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tw-pr-5",
      "data-testid": `studio-toggle-label-${_ctx.label}`
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "tw-block tw-text-xs",
          innerHTML: _ctx.label
        }, null, 8, _hoisted_4),
        _renderSlot(_ctx.$slots, "info"),
        (_ctx.tag)
          ? (_openBlock(), _createBlock(_component_StudioBadge, {
              key: 0,
              variation: "orange",
              class: "tw-ml-1.5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.tag), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.subLabel)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tw-max-w-xl tw-text-xs tw-text-slate-500",
            innerHTML: _ctx.subLabel
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createVNode(_component_StudioToggle, {
      id: _ctx.id,
      checked: _ctx.checked,
      disabled: _ctx.disabled,
      disabledReason: _ctx.disabledReason,
      "onUpdate:checked": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:checked', $event))
    }, null, 8, ["id", "checked", "disabled", "disabledReason"])
  ]))
}